import React from 'react';
import {
  TableContainer,
  TableHead,
  TableBody,
  TableBodyRow,
  TableHeadCell,
} from '../../../../../../../components/tableComponents';

export const tenantsTableComponents = {
  table: TableContainer,
  header: {
    wrapper: TableHead,
    cell: TableHeadCell,
  },
  body: {
    wrapper: TableBody,
    row: TableBodyRow,
  },
};
